import React from "react";
// Phase C.5 (Candidate System UI Language Migration): moved off hardcoded English+Marathi literals
// onto the centralized Text/dictionary.js architecture — see qualificationInfo.js.
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';
import { Tooltip } from 'antd';

function tr(key) {
  return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class QualificationTableHeader_new extends React.Component {


  render() {
    return (
      // style={{ backgroundColor: '#cbede2', color: 'brown', paddingTop: '7px', borderTopLeftRadius: '5px', borderTopRightRadius: '5px', borderColor: 'lightgrey', borderStyle: 'solid', borderWidth: '0.5px' }}

     // Phase C.7.4D-R6.4A (unified-matrix correction): R6.4 removed this column on the theory that the
     // qualification name would live in a standalone heading line above each row instead. That line
     // (combined with R6.4's un-hiding of every row's own field labels) is exactly what turned the
     // single-header table into repeated per-row mini-forms — see QualificationRow_new.jsx's own
     // comment. The Education column is restored here so there is again exactly ONE header row whose
     // 6 columns line up with the 6 columns every qualification row renders — R6.4's genuinely good
     // change (the name no longer looks like a disabled input) is kept, just back inside the matrix
     // instead of floating above it. Column widths restored to the original, staging-matching
     // 2/2/3/2/1/2 split.
     <div className="row flex-sm-row rounded-top align-items-center qualificationtableheader-row">
        <div className="col-sm-2 pl-20">
            <label>
                <div className='displayInGrid'>
                <Text k="qualificationInfo.educationLabel" />
                </div>
            </label>
        </div>
        <div className="col-sm-2 pl-20">
            <label>
                <div className='displayInGrid'>
                <Text k="qualificationInfo.specializationLabel" />
                </div>
            </label>
        </div>
        <div className="col-sm-3">
            <label>
                <div className='displayInGrid'>
                    <Text k="qualificationInfo.boardUniversityInstituteLabel" />
                </div>
            </label>
        </div>
        <div className="col-sm-2" >
            <label>
                <div className='displayInGrid'>
                    <Text k="qualificationInfo.passingYearLabel" />
                </div>
            </label>
        </div>
        <div className="col-sm-1">
            {/* Phase C.7.4D-R6.3 (§5): clarifies the combined Grade/Percent column without splitting it
                into two fields (the underlying data model is one free-text column) or changing any
                validation rule. Phase C.7.4D-R6.4/R6.4A: the tooltip is now a secondary aid only — each
                row also carries an always-visible caption ("e.g. 75 or A+") under its own field. */}
            <Tooltip title={tr('qualificationInfo.gradePercentHelpText')} placement="top">
                <label>
                    <div className='displayInGrid'>
                        <Text k="qualificationInfo.gradePercentLabel" />
                    </div>
                </label>
            </Tooltip>
        </div>
        {/* Phase C.7.4D-R6.4B (annotated correction 3): centred within its own column so it reads as
            clearly its own header cell rather than crowding against the neighbouring Grade/Percent
            column's left-aligned text. */}
        <div className="col-sm-2 text-center">
            <label>
                <div className='displayInGrid'>
                    <Text k="qualificationInfo.classLabel" />
                </div>
            </label>
        </div>
      </div>

    );
  }
}

export default QualificationTableHeader_new;